<template>
  <div
    class="person-item"
    :class="{'person-item-bordered': bordered}"
    @click="selectPerson"
    v-if="person">
    <div class="person-inner" v-if="person.activity_id === 0"></div>
    <a-icon class="person-icon" type="user" />
    <div class="person-name">{{person.name}}<span class="person-tel" v-if="showTel">{{person.tel}}</span></div>
    <slot></slot>
  </div>
</template>

<script lang="tsx">

    export default {
        name: "person-item",
        props: {
            person: Object,
            showTel: Boolean,
            bordered: Boolean
        },
        methods: {
            selectPerson() {
                this.$emit("select");
            }
        }
    }
</script>

<style lang="less">
  .person-item {
    display: flex;
    align-items: center;
    padding: 6px 16px 6px 28px;
    position: relative;
    line-height: 1;
    color: @primary-color;
    &.person-item-bordered {
      display: inline-flex;
      padding: 2px 6px;
      border-radius: 2px;
      border: 1px solid #E4E6E9;
      .person-operate {
        display: block;
      }
      .person-inner {
        position: relative;
        top: auto;
        left: auto;
        margin: 0 4px 0 0;
      }
    }
    &.person-selected {
      .person-operate {
        display: block;
      }
    }
    &.select-disable {
      color: @text-color-secondary;
      cursor: not-allowed;
      .person-operate {
        display: block;
      }
    }
    .person-operate {
      display: none;
      margin-left: 6px;
    }
  }
  .person-inner {
    position: absolute;
    top: 0;
    left: 6px;
    bottom: 0;
    margin: auto 0;
    width: 16px;
    height: 16px;
    background: url(../assets/inner.png) center / contain no-repeat;
  }
  .person-icon {
    margin-right: 6px;
  }
  .person-name {
    line-height: 20px;
    color: @text-color;
  }
  .person-tel {
    margin-left: 0.5em;
    color: @text-color-secondary;
  }
</style>
